// libraries
import { Button, DatePicker, Form } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { txt } from '../../locales/i18n';

export type DateSelectorListProps = { name: string };

export function DateSelectorList(props: DateSelectorListProps): JSX.Element {
	function renderRangePicker(field: any, index: number, remove: (index: number | number[]) => void): JSX.Element {
		return (
			<StyledFormListItem key={index} className="date-input-container">
				<Form.Item name={field.name}>
					<DatePicker.RangePicker
						showTime
						showSecond={false}
						format="ddd DD/MM-YY HH:mm"
						allowClear={false}
						minuteStep={5}
					/>
				</Form.Item>
				<Button danger onClick={() => remove(field.name)}>
					<DeleteOutlined />
				</Button>
			</StyledFormListItem>
		);
	}

	function render(fields: any[], { add, remove }: any): JSX.Element {
		return (
			<>
				{fields.map((field, index) => renderRangePicker(field, index, remove))}

				<Form.Item name="add-date">
					<Button type="dashed" onClick={add} icon={<PlusOutlined />}>
						{txt('dates.add date')}
					</Button>
				</Form.Item>
			</>
		);
	}

	return <Form.List {...props}>{render}</Form.List>;
}

const StyledFormListItem = styled.div`
	display: flex;
`;
